// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  unitRowId: __t.u64().primaryKey().name("unit_row_id"),
  structureId: __t.u64().name("structure_id"),
  unitId: __t.string().name("unit_id"),
  listed: __t.bool(),
  rentPerDay: __t.u32().name("rent_per_day"),
  notes: __t.string(),
  layoutRevision: __t.u32().name("layout_revision"),
  digest: __t.string(),
  kind: __t.string(),
  floor: __t.u32(),
  x0: __t.f32().name("x_0"),
  z0: __t.f32().name("z_0"),
  x1: __t.f32().name("x_1"),
  z1: __t.f32().name("z_1"),
  tx: __t.f32(),
  tz: __t.f32(),
  ax: __t.f32(),
  az: __t.f32(),
  ox: __t.f32(),
  oz: __t.f32(),
  keysJson: __t.string().name("keys_json"),
  source: __t.string(),
  listedBy: __t.identity().name("listed_by"),
  listedAt: __t.timestamp().name("listed_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
